import { render, staticRenderFns } from "./dropdown-notifications.vue?vue&type=template&id=13499c6e&scoped=true"
import script from "./dropdown-notifications.vue?vue&type=script&lang=js"
export * from "./dropdown-notifications.vue?vue&type=script&lang=js"
import style0 from "./dropdown-notifications.vue?vue&type=style&index=0&id=13499c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13499c6e",
  null
  
)

export default component.exports